/*
|--------------------------------------------------------------------------
| Video: Tout
|--------------------------------------------------------------------------
*/
/**
 * Tout Video
 * @namespace
 */
__gh__webApp.video.tout = {
	
	
	/**
	 * Initialize
	 */
	"init": function() {
		if (this.isDisabled()) {return;}
		this.videoTrackingInit();
	},
	
	"disableMidArticlePlayer": function(articleDOM){
		if (articleDOM){
			$(articleDOM).find(".tout-mid-article").remove();
		}
		__gh__coreData["3rdPartyData"].video.tout.isMidArticlePlayerDisabled = true;
	},
	
	
	/**
	 * Inject the Tout Mid Article player
	 * Article must be over the minimum number of characters
	 * Calculates middle paragraph and inserts player right after
	 * If article doesn't have enough characters, place at bottom of article
	 * @param {string} articleDOM - dom of the article
	 */
	"injectMidArticlePlayer": function(articleDOM){

		if (this.isMidArticlePlayerDisabled()) {return;}
		
		var $article 			= $(articleDOM),
			$articleBody		= $article.find(".article-body"),
			minChars			= 2000,
			playerHTML			= '<div class="tout-sdk tout-mid-article clear"></div>';
			relatedContentCount = __gh__coreData.globalVariables.article.loadArticle.relatedContentCount;
		
		
		//Strip html tags and check total characters
		var regex 		= /(<([^>]+)>)/ig,
			body 		= $articleBody.html(),
			body		= body.replace(regex, ""),
			totalChars 	= body.length;
	
	
		//Inject player at the end of the article
		if(relatedContentCount > 1 || (totalChars < minChars)) {
			$articleBody.append(playerHTML); 
			return;
		}
	
		
		// Inject Player in the middle of article
		var $articleGraphs = $articleBody.find("p").not(".related p"),
			injectionPoint	= Math.floor($articleGraphs.length / 2);
			
		$articleGraphs.eq(injectionPoint).after(playerHTML);
		
	},


	"loadSiteSDKLibrary": function(){
		var currentPage = __gh__webApp.currentPage;
		if (this.isDisabled() || currentPage.isArticle()) {return;}
		var toutId = __gh__coreData["3rdPartyData"].video.tout.id;
		if (typeof window.TOUT == "undefined") {
			__gh__webApp.common.loadScript({
				"src":"//platform.tout.com/sdk/v1/"+toutId+".js"
			});
		}
	},
	
	
	"videoTrackingInit": function(){
	
		__gh__webApp.common.loadScript({
			"text":"var TOUT_TRACKING = TOUT_TRACKING || {};"
		});
		
		var commonJS = __gh__webApp.common,
			section = commonJS.getObjectProperty(__gh__coreData,"pageData.categoryName");
			section = (section) ? section : commonJS.getObjectProperty(__gh__coreData,"pageData.profileName");
			section = (section) ? section : null;
		
		TOUT_TRACKING = {
			
			/**
			 * When a Tout video content started to play
			 */
		    tout_played: function(event_name,properties,extras) {
				var tracker = __gh__webApp.utilities.tracker,
					parsley = __gh__webApp.analytics.parsely;
				
	        	tracker.trackEvent({
		        	"label"		: properties.tout_uid,
		        	"action"	: "Play",
		        	"category"	: "Tout_Videos"
	        	});
				
				
				parsely.trackPlay({
					"videoID"			: properties.tout_uid,
					"imageURL" 			: extras.tout.image.poster.http_url,
					"title" 			: extras.tout.open_graph.title,
					"section" 			: section,
					"authors"			: [extras.tout.user.fullname],
					"pubDateTimestamp"	: new Date(properties.tout_published_at).getTime()
				});
		        
		    },
		    
		    
		    /**
			 * When a Tout video content progressed into 25% of it's total duration, either user fast forward or naturally play through
			 */
		    tout_played_first_quartile: function(event_name,properties,extras) {
				var tracker = __gh__webApp.utilities.tracker;
				
				tracker.trackEvent({
		        	"label"		: properties.tout_uid,
		        	"action"	: "Played_First_Quarter",
		        	"category"	: "Tout_Videos"
	        	});
	
		    },
		    
		    
		    /**
			 * When a Tout video content progressed into 50% of it's total duration, either user fast forward or naturally play through
			 */
		    tout_played_mid_point: function(event_name,properties,extras) {
				var tracker = __gh__webApp.utilities.tracker;
				
				tracker.trackEvent({
		        	"label"		: properties.tout_uid,
		        	"action"	: "Played_Mid_Point",
		        	"category"	: "Tout_Videos"
	        	});
		    },
		    
		    
		    /**
			 * When a Tout video content progressed into 75% of it's total duration, either user fast forward or naturally play through
			 */
		    tout_played_third_quartile: function(event_name,properties,extras) {
				var tracker = __gh__webApp.utilities.tracker;
				
				tracker.trackEvent({
		        	"label"		: properties.tout_uid,
		        	"action"	: "Played_Third_Quarter",
		        	"category"	: "Tout_Videos"
	        	});
		    },
		    
		    
		    /**
			 * When a Tout video content progressed into the end of it's total duration, either user fast forward or naturally play through
			 */
		    tout_played_complete: function(event_name,properties,extras) {
		        var tracker = __gh__webApp.utilities.tracker;
				
				tracker.trackEvent({
		        	"label"		: properties.tout_uid,
		        	"action"	: "Played_Complete",
		        	"category"	: "Tout_Videos"
	        	});
		        
		    },
		    
		    
		    /**
			 * When Tout video content is paused for any reason
			 */
		    tout_paused: function(event_name,properties,extras) {
		        var tracker = __gh__webApp.utilities.tracker,
		        	parsely = __gh__webApp.analytics.parsely;
				
				tracker.trackEvent({
		        	"label"		: properties.tout_uid,
		        	"action"	: "Pause",
		        	"category"	: "Tout_Videos"
	        	});
		        
		        
				parsely.trackPause(properties.tout_uid);
		        
		    }
		    
		    
		    /**
			 * When Tout player made an outbond request to the ads network in attempt to get an ad.
			 * This does NOT imply the the server will response with a ad or not.
			 */
		    //ad_requested: function(event_name, properties) {},
		    
		    
		    /**
			 * When Tout player made an outbond request to the ads network in attempt to get an ad.
			 * This does NOT imply the the server will response with a ad or not.
			 */
		    //ad_loaded: function(event_name, properties) {},
		    
		    
		    /**
			 * When the ads network resolved an ad and suggest the player to serve that ad.
			 * This does NOT guarantee the ad will be played.
			 * Since the actual ad creative may or may not be playable.
			 */
		    //ad_ready: function(event_name, properties) {},
		    
		    
		    /**
			 * When Tout player started to play the ad, because the ad is playable
			 */
		    //ad_started: function(event_name, properties) {},
		    
		    
		    /**
			 * When an ad is finished playing
			 */
		    //ad_completed: function(event_name, properties) {},
		    
		    
		    /**
	         * When anything prevent an ad from playing, can be but not limited to any of these:
	         *  - failed to communicate to the ads network for any reason
	         *  - ads network responsed with an empty response, no ads
	         *  - ads network responsed with invalid/corrupted data
	         *  - the ad content responsed from the ads network is not playable
	         *  - the player crashed for any reason
	         */
	
		    //ad_error: function(event_name, properties) {},
		    
		    
		    /**
			 * When the player initialization is completed and it's ready to go
			 */
		    //product_initialized: function(event_name, properties) {}
		};
	},
	
	
	"liveStreamPlayerHomeInit": function(){
		// check for hompage var to see if site is using this
		// if not return
		if (this.isDisabled()) {return;}
		if(!__gh__coreData["3rdPartyData"].video.tout.liveStreamPlayerHomeEnabled) {return;}
		// if true, load this.loadSiteSDKLibrary();
		this.loadSiteSDKLibrary();
	},
	
	
	"getToutId": function(){
		if (this.isDisabled()) {return null;}
		return __gh__coreData["3rdPartyData"].video.tout.id;
	},
	
	
	"isDisabled": function(){
		var commonJS = __gh__webApp.common;
		return (commonJS.isObjectPropertySet(__gh__coreData["3rdPartyData"],"video.tout.id") && __gh__coreData["3rdPartyData"].video.tout.id) ? false : true;
	},
	
	
	/**
	 * Check to see if the mid article player is disabled
	 */
	"isMidArticlePlayerDisabled": function(){
		var commonJS						= __gh__webApp.common,
			thisObject 						= __gh__webApp.video.tout,
			isMidArticlePlayerDisabled 		= commonJS.getObjectProperty(__gh__coreData["3rdPartyData"], "video.tout.isMidArticlePlayerDisabled"),
			isMobile						= __gh__webApp.device.isMobile();
	
		return (thisObject.isDisabled() || isMidArticlePlayerDisabled);
	}

};
